"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInterval = void 0;
/**
 * Checks if a variable is an interval. For an item to be an interval, it must be a non-null object with a `start`
 * and `end` property, both of which must be of type `number` or `Date`.
 * @param item
 */
function isInterval(item) {
    return (item != null &&
        typeof item === 'object' &&
        (typeof item.start === 'number' || item.start instanceof Date) &&
        (typeof item.end === 'number' || item.end instanceof Date));
}
exports.isInterval = isInterval;
